import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Navigate, Link } from '@tanstack/react-router'
import { ArrowLeftIcon } from 'lucide-react'

import { ApiError } from '@/api/errors'
import { portalApi } from '@/api/portal'
import { FormError } from '@/components/field-error'
import { Skeleton } from '@/components/ui/skeleton'
import { msg } from '@/i18n'

/**
 * Un livrable désigné par son id (lot 28 : `/portal/todo` et la cloche) :
 * on le lit, puis on ouvre sa page, rangée sous son projet.
 */
export const Route = createFileRoute('/portal/livrables/$deliverableId')({
  component: DeliverableById,
})

function DeliverableById() {
  const { deliverableId } = Route.useParams()
  const deliverable = useQuery({
    queryKey: ['portal', 'deliverable', deliverableId],
    queryFn: () => portalApi.deliverable(deliverableId),
  })
  if (deliverable.isPending) return <Skeleton className="h-40 w-full rounded-lg" />
  if (deliverable.isError) {
    return (
      <div className="space-y-3">
        <FormError>
          {deliverable.error instanceof ApiError
            ? deliverable.error.message
            : msg().portalRecipe.deliverable.gone}
        </FormError>
        {/* #401 : une page sans issue renvoie aux projets. */}
        <Link
          to="/portal/projets"
          className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
        >
          <ArrowLeftIcon className="size-3.5" aria-hidden="true" />
          {msg().common.backToProjects}
        </Link>
      </div>
    )
  }
  return (
    <Navigate
      to="/portal/projets/$projectId/livrables/$key"
      params={{ projectId: deliverable.data.project.id, key: deliverable.data.key }}
      replace
    />
  )
}
